module.exports = __webpack_public_path__ + "img/sick.9aa4bdb8.svg";